<template lang="pug">
v-container.pa-4
  v-toolbar(elevation=0)
    v-toolbar-title
      h3 Pessoa - {{person.name}}
  div.data-section
    div.space-btw
      h3 SOBRE
      v-btn(icon @click='update = !update')
        v-icon mdi-pencil
    div.my-2
      div.box-fields
        div
          span.font-weight-bold Nome
          v-text-field(v-model='person.name' :disabled='!update')
        div
          span.font-weight-bold CPF
          v-text-field(v-model='person.cpf' :disabled='!update')
    div.my-2
      span.font-weight-bold Email
      v-text-field(v-model='person.email' :disabled='!update')
    div.my-2
      span.font-weight-bold Código
      v-text-field(v-model='person.code' :disabled='!update')
    div.my-2
      span.font-weight-bold Status
      v-checkbox(v-model='person.suspended' disabled label='Suspensa')
      v-btn(text @click='updateUserStatus()') {{person.suspended ? 'Ativar pessoa' : 'Suspender pessoa'}}
    div.my-2
      span.font-weight-bold Extra
      v-text-field(v-model='person.details.extra' :disabled='!update')
    div.my-2
      span.font-weight-bold Telefone
      v-text-field(v-model='person.details.phone' :disabled='!update')
    div.my-2
      div.box-fields
        div
          span.font-weight-bold Empresa
          v-text-field(v-model='person.details.company' :disabled='!update')
        div
          span.font-weight-bold Cargo
          v-text-field(v-model='person.details.role' :disabled='!update')
    div.my-2.box-fields
      div
        span.font-weight-bold Imagem
        v-text-field(v-model='person.details.image_url' :disabled='!update')
        input(v-if='update' type='file' accept='image/*' @change='onFilePicked')
      div(v-if='imgUrl')
        v-img(:src='imgUrl' width='50%' style='margin: auto')
    div.space-btw.mt-4(v-if='update')
      v-btn(@click='update = false' :disabled='wait') Cancelar
      v-btn(@click='updateUser()' :loading='wait') Salvar
    v-snackbar(v-model='statusSnackbar')
      | Status atualizado!
      v-spacer
      v-btn(icon @click='statusSnackbar = false')
        v-icon mdi-close
</template>

<script>
import utils from '../utils/requests'

export default {
  data () {
    return {
      id: this.$route.params.id,
      person: {},
      update: false,
      wait: false,
      imgUrl: '',
      snackbar: false,
      statusSnackbar: false
    }
  },
  mounted () {
    utils.postAPI('/people/get_person_details', { 'id': this.id }).then(res => {
      console.log('result: ', res)
      this.person = res
    })
  },
  methods: {
    updateUser () {
      this.wait = true
      const data = {
        person_id: this.id,
        person: {
          name: this.person.name,
          code: this.person.code,
          cpf: this.person.cpf,
          email: this.person.email,
          extra: this.person.details.extra,
          image: this.person.details.image_url,
          phone: this.person.details.phone,
          company: this.person.details.company,
          role: this.person.details.role,
          address: '',
          address_number: '',
          address_addon: '',
          neighborhood: '',
          city: '',
          state: '',
          zip_code: ''
        }
      }
      console.log(JSON.stringify(data))
      utils.postAPI('/people/update_person', data).then(res => {
        this.wait = false
        this.update = !this.update
        this.snackbar = true
      })
    },
    updateUserStatus () {
      utils.postAPI('/people/person_activation_switch', { 'id': this.id }).then(res => {
        this.statusSnackbar = true
        window.location.reload()
      })
    }
  }
}
</script>
